function Pulser() {
  return (
    <div className='Pulser'>
      <div className='Pulser__ring' />
      <div className='Pulser__circle' />
    </div>
  );
}

export default Pulser;
